/** ! WARNING: DO NOT EDIT ! **
  This file is generated by graphql codegen.
  Make changes to *.graphql documents, not this file
**/
import type * as _Types from '_gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetCreditApplicationBdcOrgID_creditApplication_CreditApplication = { readonly __typename: 'CreditApplication', readonly salesforceCreditId: string, readonly bdcOrgId: string | null };

export type GetCreditApplicationBdcOrgID_Query = { readonly __typename: 'Query', readonly creditApplication: GetCreditApplicationBdcOrgID_creditApplication_CreditApplication | null };


export type GetCreditApplicationBdcOrgIDVariables = _Types.Exact<{
  creditApplicationId: _Types.Scalars['ID']['input'];
}>;


export type GetCreditApplicationBdcOrgID = GetCreditApplicationBdcOrgID_Query;


export const GetCreditApplicationBdcOrgIDDocument = gql`
    query GetCreditApplicationBdcOrgID($creditApplicationId: ID!) {
  creditApplication(creditApplicationId: $creditApplicationId) {
    salesforceCreditId
    bdcOrgId
  }
}
    `;

/**
 * __useGetCreditApplicationBdcOrgID__
 *
 * To run a query within a React component, call `useGetCreditApplicationBdcOrgID` and pass it any options that fit your needs.
 * When your component renders, `useGetCreditApplicationBdcOrgID` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreditApplicationBdcOrgID({
 *   variables: {
 *      creditApplicationId: // value for 'creditApplicationId'
 *   },
 * });
 */
export function useGetCreditApplicationBdcOrgID(baseOptions: Apollo.QueryHookOptions<GetCreditApplicationBdcOrgID, GetCreditApplicationBdcOrgIDVariables> & ({ variables: GetCreditApplicationBdcOrgIDVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCreditApplicationBdcOrgID, GetCreditApplicationBdcOrgIDVariables>(GetCreditApplicationBdcOrgIDDocument, options);
      }
export function useGetCreditApplicationBdcOrgIDLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCreditApplicationBdcOrgID, GetCreditApplicationBdcOrgIDVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCreditApplicationBdcOrgID, GetCreditApplicationBdcOrgIDVariables>(GetCreditApplicationBdcOrgIDDocument, options);
        }
export function useGetCreditApplicationBdcOrgIDSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCreditApplicationBdcOrgID, GetCreditApplicationBdcOrgIDVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCreditApplicationBdcOrgID, GetCreditApplicationBdcOrgIDVariables>(GetCreditApplicationBdcOrgIDDocument, options);
        }
export type GetCreditApplicationBdcOrgIDHookResult = ReturnType<typeof useGetCreditApplicationBdcOrgID>;
export type GetCreditApplicationBdcOrgIDLazyQueryHookResult = ReturnType<typeof useGetCreditApplicationBdcOrgIDLazyQuery>;
export type GetCreditApplicationBdcOrgIDSuspenseQueryHookResult = ReturnType<typeof useGetCreditApplicationBdcOrgIDSuspenseQuery>;
export type GetCreditApplicationBdcOrgIDQueryResult = Apollo.QueryResult<GetCreditApplicationBdcOrgID, GetCreditApplicationBdcOrgIDVariables>;